import SHA256 from 'crypto-js/sha256'
import { MD5 } from 'crypto-js'

// Generate fingerprint from webgl
export function getFingerprint() {
  const data = []

  // 1. Basic System Info
  data.push(navigator.language)
  data.push(navigator.hardwareConcurrency)
  data.push(navigator.userActivation)
  data.push(Intl.DateTimeFormat().resolvedOptions().timeZone)
  data.push(window.devicePixelRatio)
  data.push(window.screen.colorDepth)

  // 2. WebGL & Canvas Fingerprinting
  try {
    const canvas = document.createElement('canvas')
    const ctx = canvas.getContext('2d')
    ctx.textBaseline = 'top'
    ctx.font = '14px Arial'
    ctx.fillText('Fingerprinting-Test', 2, 2)
    data.push(canvas.toDataURL())
  } catch (e) {
    data.push('canvas-error')
  }

  // 3. Audio Context Fingerprint
  try {
    const audioCtx = new (window.OfflineAudioContext || window.AudioContext)(1, 44100, 44100)
    const oscillator = audioCtx.createOscillator()
    const compressor = audioCtx.createDynamicsCompressor()
    oscillator.connect(compressor)
    compressor.connect(audioCtx.destination)
    oscillator.start(0)
    data.push(audioCtx.sampleRate.toString())
  } catch (e) {
    data.push('audio-error')
  }

  // 4. IndexedDB Check
  data.push(window.indexedDB ? 'indexedDB-supported' : 'indexedDB-not-supported')

  // Convert data to SHA-256 hash
  // return await this.hashData(data.join('|'))
  return MD5(SHA256(data.join('|')).toString())?.toString()
}
